import React from 'react';
import { Icon } from './Icon';
import { PopoverH } from './TooltipH';

export const VideoIco = ({ children }) => {
  return <PopoverH title={children}>
    <div className=''><Icon className='_o04' style={{ fontSize: '1em' }}>videocam</Icon></div>
  </PopoverH>
}
